module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_5.31602361.png";